import React, { useRef, useState } from 'react';
import { IconButton, Tooltip, Box, TextField } from '@mui/material';
import { Done as DoneIcon, Close as CloseIcon } from '@mui/icons-material';
import { Colors } from '../assets/theme/Colors';

const NotesActionButton = ({ title, icon: Component, onClick, disabled, buttonProps = {} }) => {
  const [tooltipIsOpen, setTooltipIsOpen] = useState(false);
  const [tooltipIsEdited, setTooltipIsEdited] = useState(false);
  const noteRef = useRef();

  const iconProps = {
    fontSize: 'small',
  };

  const handleButtonClick = () => {
    setTooltipIsEdited(!tooltipIsEdited);
    setTooltipIsOpen(true);
  };

  const handleDoneClick = () => {
    if (noteRef.current === undefined) {
      noteRef.current = title;
    }
    onClick(noteRef.current);
    setTooltipIsEdited(false);
    setTooltipIsOpen(false);
  };

  const handleNoteChange = (value) => {
    noteRef.current = value;
  };

  return (
    <Tooltip
      slotProps={{
        tooltip: {
          sx: {
            backgroundColor: tooltipIsEdited ? 'common.white' : '',
            color: tooltipIsEdited ? 'common.black' : '',
            border: tooltipIsEdited ? '1px solid #E6E8ED' : '',
          },
        },
        arrow: {
          sx: {
            '&:before': {
              border: tooltipIsEdited ? '1px solid #E6E8ED' : '',
            },
            color: tooltipIsEdited ? 'common.white' : '',
          },
        },
      }}
      title={(
        <Box>
          {!tooltipIsEdited ? (
            title || '-'
          ) : (
            <TextField
              name="note"
              variant="outlined"
              defaultValue={title}
              multiline
              minRows={7}
              onChange={({ target }) => handleNoteChange(target.value)}
              inputProps={{
                maxLength: 140,
              }}
            />
          )}
          {tooltipIsEdited && (
            <Box display="flex" justifyContent="end" mt={1}>
              <Tooltip title="Update note">
                <IconButton sx={{ color: Colors.green.main }} onClick={handleDoneClick} size="large">
                  <DoneIcon {...iconProps} />
                </IconButton>
              </Tooltip>
              <Tooltip title="Close">
                <IconButton
                  sx={{ color: Colors.errorText }}
                  onClick={() => {
                    setTooltipIsEdited(false);
                    setTooltipIsOpen(false);
                  }}
                  size="large"
                >
                  <CloseIcon {...iconProps} />
                </IconButton>
              </Tooltip>
            </Box>
          )}
        </Box>
      )}
      placement="top"
      disableInteractive={!tooltipIsEdited}
      open={tooltipIsOpen}
      onOpen={() => setTooltipIsOpen(true)}
      onClose={() => (tooltipIsEdited ? null : setTooltipIsOpen(false))}
    >
      <span
        style={{
          display: 'inline-block',
          ...(disabled && { cursor: 'not-allowed' }),
        }}
      >
        <IconButton
          sx={{ margin: 0.5 }}
          color="primary"
          onClick={handleButtonClick}
          disabled={disabled}
          {...buttonProps}
          size="large"
        >
          {Component && (
            <Component {...iconProps} />
          )}
        </IconButton>
      </span>
    </Tooltip>
  );
};

export default NotesActionButton;
